<div class="padding-md wrap">
  <div *ngIf="(profile$ | async) === null" class="loader profile">
    <ion-spinner class="app-spinner"></ion-spinner>
  </div>
  <div [hidden]="(profile$ | async) === null">
    <div class="header">
      <div class="icon settings">
        <app-svg-icon
          name="settings"
          (click)="onGoToProfileSettings()"
        ></app-svg-icon>
      </div>
      <div class="fullname">{{ (profile$ | async)?.name }}</div>
      <div class="icon logout">
        <app-svg-icon name="logout" (click)="onLogout()"></app-svg-icon>
      </div>
    </div>
    <app-subsidy-wallet
      [subsidyAmount]="(subsidyAmount$ | async) || 0"
      (infoClicked)="onSubsidyInfoClicked()"
      (ctaClicked)="onManageSubsidiesClicked()"
    ></app-subsidy-wallet>
  </div>
  <app-tabs [model]="tabsModel" (tabClicked)="onSelectTab($event)"></app-tabs>

  <!-- <app-todays-deliveries
    [hidden]="tabsModel.activeTabIndex !== 0"
  ></app-todays-deliveries> -->

  <app-order-list
    [orders]="userOrders$ | async"
    [hidden]="tabsModel.activeTabIndex !== 1"
  ></app-order-list>
</div>
